<template>
    <div class="invoice-record">
        <base-header :head_id="head_id" :name="name" :account_list="account_list"></base-header>
        <base-title :title="`发票中心`" :title2="`申请开票`" :path2="`/invoice`"></base-title>

        <div class="record-box" v-if="is_show && apply_log_list.length>0">
            <div class="log-wrapper" style="overflow-x:hidden">
                <ul class="list">
                    <li v-for="(item, index) in apply_log_list" class="list-item" :key="index">
                        <div class="money">{{`￥${item.money}`}}</div>
                        <div class="msg">
                            <p class="time">{{item.create_time.replace('T', ' ').slice(0,item.create_time.lastIndexOf(':'))}}</p>
                            <p class="source">{{item.invoice}}</p>
                        </div>
                        <div class="status">
                            <p class="over" v-if="item.status == 1 && item.download_status == 1" @click="handleCopyContent(item)">发票地址</p>
                            <button v-else-if="item.status == 1" class="btn-down" @click="download_file(item, index)">发票地址</button>
                            <p v-else>{{item.status == 1? '开票成功': item.status == 2? '开票失败' : '开票中…'}}</p>
                        </div>
                        <div class="divider"></div>
                    </li>
                </ul>
            </div>

            <div class="toast">
                如开票资料无误，通常7个工作日内开具完成
                <br />180天内可在发票记录中下载发票
            </div>
        </div>

        <div class="no-data" v-else-if="is_show && apply_log_list.length==0">
            <p style="margin-bottom:.2rem">
                <span>无开票申请记录</span>
            </p>
            <p>当月充值发票请在下月自助申请</p>
            <p>12个月之前充值订单开票请联系在线客服</p>
        </div>
    </div>
</template>
<script>
import { baseUrls } from '@/utils/baseUrlConfig'
const base_url = baseUrls.invoice_url

export default {
    name: 'invoice-record',
    data() {
        return {
            is_show: 0,
            apply_log_list: [],
            head_id: this.$storage.getHeadId(),
            name: this.$storage.getUserName(),
            token: this.$storage.getAuth(),
            total: 0,
            account_list: JSON.parse(this.$storage.getAccountList()),
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (from.path != "/invoice" && vm.$common.checkToken(vm.token)){
                vm.$http.set_anchor(4, vm.token)
                // console.log('写入锚点====发票');
            }
        });
    },
    created() {
        this.get_list()
    },
    methods: {
        get_list() {
            this.$http.q_hd('GetMonthLog', base_url, { token: this.token, type: 2 }, true).then((res) => {
                if (res.code == 0 && res.msg && res.msg.length > 0) {
                    this.apply_log_list = res.msg
                } else {
                    this.apply_log_list = []
                }
                this.is_show = 1
            })
        },
        handleCopyContent(item) {
            let content = item.money + '元发票下载地址：' + item.invoice_file;
            var input = document.createElement('input') // 创建input对象
            input.value = content // 设置复制内容
            document.body.appendChild(input) // 添加临时实例
            input.select() // 选择实例内容
            document.execCommand('Copy') // 执行复制
            document.body.removeChild(input) // 删除临时实例
            this.$message.success('发票地址复制成功！')
        },
        // 下载文件
        download_file(item, index) {
            item.download_status = 1
            this.$set(this.apply_log_list, index, item)
            this.handleCopyContent(item);
            // item.invoice_file = item.invoice_file.replace('http://', 'https://')
            // item.invoice_file = 'https://www.09game.com/statics/test/test.zip';
            // alert(item.invoice_file)
            // window.location.href = item.invoice_file + '?v=' + (new Date().getTime());
            // this.$message.info('如无法下载，请至电脑版个人中心进行下载');
            this.update_download(item, index)
        },
   
        // 更新下载状态
        update_download(item, index) {
            this.$http.q_hd('SendUpload', base_url, { token: this.token, log_id: item.log_id }).then((res) => {
                if (res.code == 0) {
                }
            })
        },
    },
}
</script>
<style lang="scss" scoped>
.invoice-record {
    width: 100%;
    height: 100%;
    .record-box {
        width: 100%;
        height: calc(100vh - 4.8rem);
        margin: 0 auto;
        position: relative;

        .log-wrapper {
            width: 100%;
            height: calc(100vh - 5.8rem);
            margin: 0 auto;
            position: relative;
            p {
                font-size: 0.22rem;
                color: #919191;
                text-align: center;
                width: 100%;
                height: 0.3rem;
                line-height: 0.3rem;
            }
            .list {
                width: 100%;
                height: calc(100%);
                padding: 0 3%;
                .list-item {
                    background: #ffffff;
                    border-radius: 0.2rem;
                    width: 100%;
                    height: 1.5rem;
                    position: relative;
                    margin-bottom: 0.2rem;
                    .divider {
                        width: 0.02rem;
                        height: 2.56rem;
                        background: #dddddd;
                        position: absolute;
                        top: 0.11rem;
                        right: 1.8rem;
                        transform: scale(0.5);
                        transform-origin: left top;
                    }
                    .money {
                        width: 4.8rem;
                        color: #c39b5e;
                        font-size: 0.32rem;
                        // height: 0.26rem;
                        line-height: 0.26rem;
                        padding: 0.34rem 0 0 0.23rem;
                        display: block;
                    }
                    .msg {
                        width: 4.6rem;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding: 0.37rem 0 0 0.22rem;
                        p {
                            text-align: left;
                            display: inline-block;
                            color: #919191;
                            font-size: 0.22rem;
                            height: 0.21rem;
                            line-height: 0.21rem;
                            &.source {
                                text-align: right;
                                color: #2f92eb;
                            }
                        }
                    }

                    .status {
                        position: absolute;
                        right: 0;
                        top: 0;
                        width: 1.8rem;
                        height: 100%;
                        text-align: center;
                        font-size: 0.22rem;
                        vertical-align: middle;
                        .btn-down {
                            margin-top: 0.45rem;
                            width: 1.5rem;
                            height: 0.56rem;
                            background: rgba(195, 155, 94, 0);
                            border: 0.01rem solid #c4a160;
                            border-radius: 0.28rem;
                            color: #c39b5e;
                            font-size: 0.26rem;
                        }
                        p {
                            color: #272727;
                            height: 1.5rem;
                            line-height: 1.5rem;
                            &.over {
                                color: #919191;
                            }
                        }
                    }
                }
            }
        }

        .toast {
            position: absolute;
            bottom: 0;
            left: 0;
            font-size: 0.22rem;
            color: #919191;
            text-align: center;
            width: 100%;
            height: 0.9rem;
            line-height: 0.28rem;
        }
    }

    .no-data {
        width: 100%;
        margin-top: 2.5rem;
        p {
            font-size: 0.22rem;
            color: #919191;
            text-align: center;
            width: 100%;
            height: 0.3rem;
            line-height: 0.3rem;
            span {
                display: block;

                color: #212121;
                font-size: 0.36rem;
                font-weight: bold;
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/view/invoice/log.vue